import { useSortable, arrayMove, SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { useState, useEffect } from 'react';
import { DndContext, rectIntersection, useSensor, useSensors, PointerSensor } from '@dnd-kit/core';

export function SortableItem({ id, children, itemClass }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 100 : 'auto',
    opacity: isDragging ? 0.5 : 1,
    cursor: 'grab',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners} className={itemClass}>
      {children}
    </div>
  );
}

export function SortableContainer({ items, onOrderChange, renderItem, containerClass, endItem, containerStyles, itemClass }) {
  const [list, setList] = useState(items);

  useEffect(() => setList(items), [items]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  const handleDragEnd = (event) => {
    try {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = list.findIndex((i) => i.id === active.id);
            const newIndex = list.findIndex((i) => i.id === over.id);
            
            const newList = arrayMove(list, oldIndex, newIndex);
            setList(newList);
            if (onOrderChange)
                onOrderChange(newList);
        }
    } catch {}
  };

  return (
    <DndContext sensors={sensors} collisionDetection={rectIntersection} onDragEnd={handleDragEnd}>
      <SortableContext items={list} strategy={rectSortingStrategy}>
        <div className={containerClass} style={containerStyles}>
          {list.map((item, i) => (
            <SortableItem key={item.id || String(i)} id={item.id || String(i)} itemClass={itemClass}>
              {renderItem(item, i)}
            </SortableItem>
          ))}
          {!!endItem ? endItem : null}
        </div>
      </SortableContext>
    </DndContext>
  );
}